module.exports = __webpack_public_path__ + "img/call.7393f987.svg";